function init_hall2019anim(from_php){
    var main=$(".place.hall2019anim");
    var spineResource;
    if(_ON_DEV){
        console.log(from_php)
    }
    
    
    
    var animCanv=main.find("#techearAnim");
    var animArr=[];
    var cumState={"state":""};
    
    
    var soundIndex=_moduleTimeHandler.getNewIndex();
    var lastSound=false;
    
//    from_php.anim_max=2;
    
    function initView(){
        //anim_max
        var name,name_int,need,name_push,obj,active,url;
        
        for(name in from_php.level_need){
            need=intval(from_php.level_need[name]);
            name_int=intval(need);
            obj=main.find(".showGoodJS[data-i='"+name+"']");
            active=false;
            if(need<=from_php.girls_count){
                active=true;
                obj.removeClass("unable");
                name_push=name;
                if($.isNumeric(name_push)){
                    name_push=intval(name_push);
                }
                animArr.push(name_push);
                
            }
            if(name_int>0 && name_int<=10){
                if(active){
                    url="/gfx/place/hall2019anim/icons/"+name+".png";
                }
                else{
                    url="/gfx/place/hall2019anim/icons/"+name+"_un.png";
                }
                obj.find(".icon").css("background-image","url("+_IMG_SERV+url+")");
            }
        }
        
        
        
    }
    initView();
    $.handleBottomMenu();
    $.handleSelect();
    if(animArr.length==0){
        return false;
    }
    
    
    $.addToPlacePreloader(function(){
//        _moduleEvents.trigger("loadEnd");
    },[],{addToLoader:1});
    
    
    
    
    function animTeacher(animCanv,anim_ava){
        if(anim_ava.length==0){
            return false;
        }
//        anim_ava=[6];
        var v=4;
        this.path_url={
            "1_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/1/1/skeleton.json",
            "2_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/2/1/skeleton.json",
            "2_2":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/2/2/skeleton.json",
            "3_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/3/1/skeleton.json",
            "3_2":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/3/2/skeleton.json",
            "4_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/4/1/skeleton.json",
            "5_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/5/1/skeleton.json",
            "5_2":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/5/2/skeleton.json",
            "6_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/6/1/skeleton.json",
            "6_2":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/6/2/skeleton.json",
            "6_3":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/6/3/skeleton.json",
            "7_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/7/1/skeleton.json",
            "8_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/8/1/skeleton.json",
            "9_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/9/1/skeleton.json",
            "10_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/10/1/skeleton.json",
            "11_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/11/1/skeleton.json",
            "12_1":_IMG_SERV+"/gfx/place/hall2019anim/anims"+v+"/12/1/skeleton.json",
        };
        this.anim_queue={
            "1":[{key:"1_1",arr:["animation"]}],
            "2":[{key:"2_1",arr:["animation"]},{key:"2_2",arr:["animation"]}],
            "3":[{key:"3_1",arr:["animation"]},{key:"3_2",arr:["animation"]}],
            "4":[{key:"4_1",arr:["animation"]}],
            "5":[{key:"5_1",arr:["animation"]},{key:"5_2",arr:["animation"]},{key:"5_2",arr:["animation2"]}],
            "6":[{key:"6_1",arr:["animation"]},{key:"6_2",arr:["animation","animation2"]},{key:"6_3",arr:["animation"]}],
            "7":[{key:"7_1",arr:["animation"]}],
            "8":[{key:"8_1",arr:["animation"]}],
            "9":[{key:"9_1",arr:["animation"]}],
            "10":[{key:"10_1",arr:["animation"]}],
            "cum":[{key:"11_1",arr:["animation"]},{key:"11_1",arr:["animation2"]}],
            "12":[{key:"12_1",arr:["animation"]}],
        };
        this.anim_conf={
            "1":{},
            "2":{},
            "3":{},
            "4":{},
            "5":{},
            "6":{},
            "7":{},
            "8":{},
            "9":{},
            "10":{},
            "cum":{},
            "12":{},
        };
        
        
        this.app=new PIXI.Application({
            width: 1280, height: 780,antialias: true,transparent:true,
            view:animCanv[0]
        });
        this.mainCointainer=new PIXI.Container();
        this.coverContainer=new myPixiElement.container({});
        this.app.stage.addChild(this.mainCointainer);
        this.app.stage.addChild(this.coverContainer);
        
        
        this.spineArr={};
        this.anim_ava=copyArray(anim_ava);
        this.anim_id=-1;
        var app=this.app;
        this.curSound="";
        
        this.storage_anim={block:0,cur:""};
        
        
        
        var loaderMain = new PIXI.loaders.Loader();
        var i,bum;
        var need_keys=[],k,arr;
        for(i in this.anim_queue){
            arr=this.anim_queue[i];
            if(in_array(i,this.anim_ava)){
                for(k in arr){
                    bum=arr[k];
                    if(!in_array(bum.key,need_keys)){
                        need_keys.push(bum.key);
                        
                        loaderMain.add(bum.key,this.path_url[bum.key]);
                    }
                }
                
            }
        }

        loaderMain.load(function(loader, resources){
            spineResource=resources;



            animCanv.trigger("was_loaded");

        });
        _moduleEvents.one("moduleClear",function(){
            if(typeof app!="undefined" && app!=null){
                app.destroy();
            }
            if(typeof loaderMain.reset!="undefined"){
                loaderMain.reset();
            }
        });
        return this;
    };
    animTeacher.prototype={
        init:function(){
            
            var thc=this;
            this.main_ticker=this.app.ticker.add(
                function(delta){thc.gameLoop(delta);}    
            );
    
    
            var i,bum;
            var need_keys=[],k,arr,anim_id;
            for(i in this.anim_queue){
                arr=this.anim_queue[i];
                if(in_array(i,this.anim_ava)){
                    for(k in arr){
                        bum=arr[k];
                        if(!in_array(bum.key,need_keys)){
                            anim_id=bum.key;
                            need_keys.push(anim_id);
                            
                            
                            this.spineArr[anim_id]=new myPixiElement.spine({
                                img:anim_id,
                                spine_conf:{
                                    spineResource:spineResource,
                                    updateAnim:true,
                                    freeze_part:0,
                                    onAnimComplete:function(){
                                        thc.animEnd(this);
                                    }
                                }
                            });
                            this.spineArr[anim_id].alpha=0;
                            this.mainCointainer.addChild(this.spineArr[anim_id]);
                            

                        }
                    }

                }
            }
    
            
            if(this.anim_ava.length){
                if(from_php.show_last>0){
                    this.showAnim(this.anim_ava[this.anim_ava.length-1]);
                }
                else{
                    this.showAnim(this.anim_ava[0]);
                }
                
            }
            
//            var th=this;
//            th.spineArr["6_1"].alpha=1;
//            _moduleTimeHandler.add(function(){
//                th.spineArr["6_1"].playAnim("animation");
//            },500);
            
            
        },
        
        playSound:function(type_id){
            _moduleTimeHandler.clear(soundIndex);
            var type2obj={
                
                "0":{name:"walk_lose_all","duration":9000},
                "1":{name:"girl_moan_new","duration":9000},
                "2":{name:"pvpsuck","duration":5000},
                "4":{name:"girl_moan_new","duration":3000},
                "5":{name:"girl_moan","duration":3000},
                "6":{name:"girl_play","duration":0},
            };
            if(typeof type2obj[type_id]=="undefined"){
                return false;
            }
            var nameObj=type2obj[type_id];
            if(lastSound){
                _mySound.stopSound(lastSound);
            }
            if(nameObj.name){
                
                var thc=this;
                if(nameObj.duration){
                    _moduleTimeHandler.set(soundIndex,function(){
                        lastSound=_mySound.playSound(nameObj.name);
                    },nameObj.duration);
                }
                else{
                    lastSound=_mySound.playSound(nameObj.name);
                }
            }
        },
        gameLoop:function(delta){
            var i,k,anim_id;
            for(anim_id in this.spineArr){
//                this.spineArr[anim_id].myUpdate(delta);
            }
            this.coverContainer.myUpdate(delta);
            if(this.storage_anim.cur!=""){
                this.spineArr[this.storage_anim.cur].myUpdate(delta);
            }
//            
        },
        showAnim:function(anim_id){
            if(!in_array(anim_id,this.anim_ava) || this.storage_anim.block){
                return false;
            }
            this.storage_anim.block=1;
            this.stopLast();
            
            
            
            this.anim_id=anim_id;
            var queue=copyArray(this.anim_queue[anim_id]);
            var loop=queue.pop();
            var conf=this.anim_conf;
            
            this.storage_anim.queue=queue;
            this.storage_anim.loop=loop;
            this.storage_anim.block=0;
            this.playNext();
            
        },
        stopLast:function(){
             if(this.storage_anim.cur!=""){
                var cur_obj=this.spineArr[this.storage_anim.cur];
//                cur_obj.myReset();
                cur_obj.clearCompleteOnce();
                cur_obj.alpha=0;
            }
        },
        playNext:function(){
            this.stopLast();
            
            
            var anim;
            if(this.storage_anim.queue.length>0){
                anim=this.storage_anim.queue.shift();
            }
            else{
                anim=this.storage_anim.loop;
            }
            
            this.storage_anim.cur=anim.key;
            
            
            var cur_obj=this.spineArr[anim.key];
            cur_obj.clearCompleteOnce();
            
            var i,i_max=anim.arr.length,anim_name;
            for(i=1;i<i_max;i++){
                anim_name=anim.arr[i];
                cur_obj.onCompleteOnce(function(){
                    this.playAnim(anim_name);
                });
            }
            cur_obj.alpha=1;
            cur_obj.playAnim(anim.arr[0]);
        },
        
        animEnd:function(spine_obj){
            this.playNext();
        },
    };
    main.find(".book[g_id='1']").on("open",function(e,val){
        if(typeof from_php.level_need[val]=="undefined"){
            return false;
        }
        var need=intval(from_php.level_need[val]);
        $(this).find(".girlNeedJS").html(need-from_php.girls_count);
    });
    
    
    var animObj=new animTeacher(animCanv,animArr);
    animCanv.one("was_loaded",function(){
        $.triggerPlacePreloader(1);
        animObj.init();
        main.find(".showGoodJS").click(function(){
            var th=$(this),val=th.attr("data-i");
            if(th.is(".unable")){
                main.find(".book[g_id='1']").bookUse("show",1,val);
                return false;
            }
            animObj.showAnim(val);
            var buttonPlay = main.find(".myLink.btnBigPink");
            if(intval(val)===8){
                buttonPlay.animate({right:550});
            }else if(buttonPlay.css("right") === "550px"){
                buttonPlay.animate({right:150});
            }
        });
    });
    
    
    
    
    
    
    
    _moduleEvents.one("moduleClear",function(){
        _mySound.stopSoundAll();
    });
    
}